export default function getResource(label, vars = []) {
    const resources = {
        youJustMissedThese: 'You Just Missed These',
        rougeBadge: 'ROUGE'
    };
    return resources[label];
}
